var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useIsRTL, useSyncRef } from '@ui5/webcomponents-react-base';
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { createUseStyles } from 'react-jss';
import { BusyIndicatorSize } from '../../enums/BusyIndicatorSize';
import { BusyIndicator } from '../../webComponents/BusyIndicator';
import { Label } from '../../webComponents/Label';
import { FlexBox } from '../FlexBox';
import styles from './FilterGroupItem.jss';
const useStyles = createUseStyles(styles, { name: 'FilterGroupItem' });
const emptyObject = {};
/**
 * Represents a filter belonging to the `FilterBar`.
 */
export const FilterGroupItem = forwardRef((props, ref) => {
    const classes = useStyles();
    const { groupName, considerGroupName, label, labelTooltip, required, visible, visibleInFilterBar, children, style, loading, className, slot } = props, rest = __rest(props, ["groupName", "considerGroupName", "label", "labelTooltip", "required", "visible", "visibleInFilterBar", "children", "style", "loading", "className", "slot"]);
    const inFB = props['data-in-fb'];
    const [componentRef, filterGroupItemRef] = useSyncRef(ref);
    const isRtl = useIsRTL(filterGroupItemRef);
    const transformMarginRight = isRtl ? 'marginLeft' : 'marginRight';
    const styleClasses = clsx(className, inFB ? classes.filterItem : classes.filterItemDialog);
    const inlineStyle = Object.assign({ [transformMarginRight]: '1rem' }, style);
    if (!required && (!visible || (inFB && !visibleInFilterBar)))
        return null;
    return (React.createElement("div", Object.assign({ ref: componentRef, slot: slot }, rest, { className: styleClasses, style: inFB ? inlineStyle : emptyObject }),
        React.createElement("div", { className: inFB ? classes.innerFilterItemContainer : classes.innerFilterItemContainerDialog },
            React.createElement(FlexBox, null,
                React.createElement(Label, { title: labelTooltip !== null && labelTooltip !== void 0 ? labelTooltip : label, required: required }, `${considerGroupName && groupName !== 'default' ? `${groupName}: ` : ''}
          ${label}`)),
            loading ? (React.createElement(BusyIndicator, { className: classes.loadingContainer, active: true, size: BusyIndicatorSize.Small })) : (children))));
});
FilterGroupItem.displayName = 'FilterGroupItem';
FilterGroupItem.defaultProps = {
    groupName: 'default',
    visible: true,
    required: false,
    label: ''
};
